<template>
  <div class="personnel-edit">
    <FormInfo :formData="formData" :isEdit="true"></FormInfo>
  </div>
</template>

<script>
import FormInfo from "./personnel-form";

import { _adminSingleInfo } from "@/api/admin";

export default {
  data() {
    return {
      formData: {}
    };
  },
  created() {
    this.adminSingleInfo();
  },
  components: {
    FormInfo
  },
  methods: {
    adminSingleInfo() {
      _adminSingleInfo({
        params: {
          id: this.$route.params.id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.formData = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>